import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import Thermal from 'components/thermals/Thermal';
import PageWrapper from 'components/utils/PageWrapper';
import { GENERATION_ASSET_TYPE_KEY } from 'constants/thermal';
import Thermals from 'pages/Thermals';
import thermalPlaceholder from '../images/thermal-unselected.png';

export const thermalRoutes = {
    path: '/thermal',
    element: (
        <PageWrapper titleId="generation_asset_title">
            <Thermals type={GENERATION_ASSET_TYPE_KEY} key={GENERATION_ASSET_TYPE_KEY} />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={thermalPlaceholder} page="Thermal" noun="configuration" />,
        },
        {
            path: ':thermalId',
            element: <Thermal type={GENERATION_ASSET_TYPE_KEY} />,
        },
    ],
};
